import { createAction, props } from "@ngrx/store";
import { IErrors } from "../../models/error";
import { IResponse } from "../../models/admin";
import { ISubscriptionPlanInfo } from "../../models/Subscription";

enum SubscriptionActions {
    // Fetch the Subscriptions
    FetchSubscriptions = '[Subscription] Fetch Subscriptions',
    FetchSubscriptionsSuccess = '[Subscription] Fetch Subscriptions Success',
    FetchSubscriptionsFailure = '[Subscription] Fetch Subscriptions Failure',
}

// Fetch Subscriptions
export const FetchSubscriptionsAction = createAction(
    SubscriptionActions.FetchSubscriptions
);
export const FetchSubscriptionsSuccessAction = createAction(
    SubscriptionActions.FetchSubscriptionsSuccess,
    props<{ response: IResponse<ISubscriptionPlanInfo[]> }>()
);
export const FetchSubscriptionsFailureAction = createAction(
    SubscriptionActions.FetchSubscriptionsFailure,
    props<{ error: IErrors }>()
);
